import type { UserDoc } from './types';

// The instructor addendum that rides in a CFI's DocuSign envelope. New packets
// carry v3 (gen_packet_jacob_layout.py ADD_VERSION). Carter and Kate signed v2 on
// 10/20/2026 and stay on it — recording v3 for them would be a false record.
// The dry lease inside the DocuSign packet (gen_packet_jacob_layout.py). It is NOT
// lib/lease.ts LEASE_VERSION, which tags the in-app lease text. Carter and Kate
// signed this one on 10/20–21/2026; recording v13 for them was a false record.
export const DOCUSIGN_LEASE_VERSION = 'ajm-dry-lease-v14-fleet-2026-10-20';

// v14 DocuSign lease §7.3/§7.5 (10/20/26): the renter's certificate is required before ANY
// flight, dual or solo, and a lapse stops all flying. Earlier leases (v13 and the backfilled
// ones) had §11.2's dual-only grace. No lease yet = signing v14, so the new rule.
export function proofBeforeAnyFlight(u: { leaseSignedVersion?: string } | null | undefined): boolean {
  const v = u?.leaseSignedVersion || '';
  return !v || /-v(1[4-9]|[2-9]\d)\b/.test(v);
}

export const INSTRUCTOR_ADDENDUM_VERSION = 'ajm-instructor-addendum-v3-fleet-2026-10-20';
const ADDENDUM_V2_SIGNERS = ['cartermattmoore@gmail.com', 'donaldson.kate@hotmail.com'];

export function addendumVersionFor(u: Pick<UserDoc, 'email'>): string {
  return ADDENDUM_V2_SIGNERS.includes((u.email || '').toLowerCase())
    ? 'ajm-instructor-addendum-v2-fleet-2026-10-20'
    : INSTRUCTOR_ADDENDUM_VERSION;
}

/** Documents approved (or ready to be), but the executed lease isn't recorded —
 *  i.e. the DocuSign is out or back and waiting on the owner's one click. */
export function awaitingLease(u: Pick<UserDoc, 'status' | 'leaseSignedAt'>): boolean {
  return (u.status === 'active' || u.status === 'verification_pending') && !u.leaseSignedAt;
}
